import { SocketService } from "@libs/socket/socket_service";
import { DriverSocketMsg, DriverSocketMsgType } from "@libs/types/message";
import { compare } from "compare-versions";

export class MusicSocket {
  private static instance: MusicSocket | null = null

  private static onOpenCallback: (value: boolean) => void = () => { }

  private socketService: SocketService = new SocketService({
    autoReconnect: false
  })

  onMusicSocketClose: (value: unknown) => void = () => { }

  constructor() {
    this.initSocketConnection();
    this.socketService.setEventHandlers({
      onClose: () => {
        this.socketService.disconnect()
        MusicSocket.onOpenCallback(false)
        this.onMusicSocketClose(true)
      },
      onOpen: () => {
        MusicSocket.onOpenCallback(true)
      }
    })
  }

  public static async getIns() {
    if (MusicSocket.instance == null || !MusicSocket.instance.checkSocket()) {
      MusicSocket.instance = new MusicSocket()

      const open = new Promise((resolve) => {
        MusicSocket.onOpenCallback = resolve
      })
      await open

    }
    return MusicSocket.instance
  }

  private initSocketConnection() {
    this.socketService.connect(new WebSocket("ws://127.0.0.1:8083/entry"))
  }

  checkSocket() {
    return this.socketService.checkSocketIsOpen()
  }

  async checkSocketVersion() {
    const sendData = {
      Type: DriverSocketMsgType.MTVersionSVC,
      Data: null,
    } as DriverSocketMsg<any>
    let res = await this.send(sendData)
    if (typeof res === "string" && compare(res, "2.4.7", '>=')) {
      return true
    }
    return false
  }

  setMusicDataHandler(func: (data: number[]) => void) {
    this.socketService.setHandler(DriverSocketMsgType.MSSendMusicData, func)
  }

  async subscriberMusicSocketClose() {
    return new Promise((resolve) => {
      this.onMusicSocketClose = resolve
    })
  }

  async send(data: DriverSocketMsg<any>) {
    return this.socketService.askTypeAndData(data)
  }

}